/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.filters').factory('filtersService', filtersService);

    filtersService.$inject = ['$rootScope', '$q', '$http', 'filterUtils', 'endpoints', 'wtNotifications', 'AccountContainer'];

    function filtersService($rootScope, $q, $http, filterUtils, endpoints, wtNotifications, AccountContainer) {
        var selectedAccountId = null;

        var formatFilterForSaving = function prepareFilterForSaving(filter) {
            filterUtils.omitFilterProperties(filter.specification.containers,
                ['id', 'internalObject', 'containerId', 'containerIndex', 'mapping']);
            _.chain(filter).get('specification.containers').forEach(function(container) {
                if (!_.chain(container).get('containers').isArray().valueOf()) {
                    container.containers = [];
                }
            }).valueOf();
            return filter;
        };

        var formatFilterAfterLoading = function prepareFilterAfterLoading(filter) {
            filterUtils.addRandomIdsToContainerFilterLists(filter.specification.containers);
            return filter;
        };

        return {
            getSelectedAccountId: function() {
                return selectedAccountId;
            },

            setSelectedAccountId: function(accountId) {
                selectedAccountId = accountId;
            },

            getAllFilters: function() {
                var deferred = $q.defer();
                var apiAllFilters = angular.copy(endpoints.apiAllFilters);

                // no caching
                apiAllFilters.url += '?ts=' + Date.now();

                $http(apiAllFilters)
                    .then(function(response) {
                        selectedAccountId = null;
                        deferred.resolve(response.data);
                    })
                    .catch(function() {
                        deferred.reject('MSG.ROLES_FAIL');
                    });

                return deferred.promise;
            },

            getFilter: function(filterId) {
                var deferred = $q.defer();
                var apiFilterDetails = angular.copy(endpoints.apiFilterDetails);
                apiFilterDetails.url = apiFilterDetails.url.replace(/%filterId/, filterId);

                $http(apiFilterDetails)
                    .then(function(response) {
                        selectedAccountId = response.data.accountId;
                        deferred.resolve(formatFilterAfterLoading(angular.copy(response.data)));
                    })
                    .catch(function() {
                        wtNotifications.error('WARN.ANALYSISFILTER.DOESNOTEXIST');
                        deferred.reject();
                    });

                return deferred.promise;
            },

            createFilter: function(filter) {
                var deferred = $q.defer();
                var apiFilterCreate = angular.copy(endpoints.apiFilterCreate);

                apiFilterCreate.data = formatFilterForSaving(angular.copy(filter));

                $http(apiFilterCreate)
                    .then(function(response) {
                        deferred.resolve(response.config.data);
                    })
                    .catch(function(response) {
                        deferred.reject(response.data);
                    });

                return deferred.promise;
            },

            updateFilter: function(filter) {
                var deferred = $q.defer();
                var apiFilterUpdate = angular.copy(endpoints.apiFilterUpdate);

                apiFilterUpdate.url = apiFilterUpdate.url.replace(/%filterId/, filter.id);
                apiFilterUpdate.data = formatFilterForSaving(angular.copy(filter));

                $http(apiFilterUpdate)
                    .then(function(response) {
                        deferred.resolve(response.config.data);
                    })
                    .catch(function() {
                        deferred.reject('MSG.FILTER_NOT_FOUND');
                    });

                return deferred.promise;
            },

            deleteFilter: function(filterId) {
                var deferred = $q.defer();
                var apiFilterDelete = angular.copy(endpoints.apiFilterDelete);
                apiFilterDelete.url = apiFilterDelete.url.replace(/\%filterId/g, filterId);
                apiFilterDelete.data = null;

                $http(apiFilterDelete)
                    .then(function() {
                        deferred.resolve();
                    })
                    .catch(function(error) {
                        deferred.reject(error.data);
                    });

                return deferred.promise;
            },

            getDimensionsAndMetrics: function() {
                var deferred = $q.defer();
                var apiDimsAndMets = angular.copy(endpoints.apiDimensionsAndMetrics);
                apiDimsAndMets.url = apiDimsAndMets.url.replace(/%accountId/, selectedAccountId);

                // no caching
                apiDimsAndMets.url += '?ts=' + Date.now();

                $http(apiDimsAndMets)
                    .then(function(response) {
                        deferred.resolve(response.data);
                    })
                    .catch(function() {
                        deferred.reject('MSG.ROLES_FAIL');
                    });

                return deferred.promise;
            },

            getAvailableUsersForAccount: function(accountId, filterId) {
                var deferred = $q.defer();
                var apiAvailableUsersForAccount = angular.copy(endpoints.apiAvailableUsersForAccount);
                apiAvailableUsersForAccount.data = {
                    accountId: accountId,
                    filterId: filterId
                };

                // no caching
                apiAvailableUsersForAccount.url += '?ts=' + Date.now();

                $http(apiAvailableUsersForAccount)
                    .then(function(response) {
                        deferred.resolve(response.data);
                    })
                    .catch(function() {
                        deferred.reject('MSG.ERROR');
                    });

                return deferred.promise;
            },

            getAccountNameById: function(accountId, serviceAccounts) {
                if (accountId && serviceAccounts && serviceAccounts.length) {
                    var wantedAccount = _.find(serviceAccounts, function(serviceAccount) {
                        return serviceAccount.account.accountId === accountId;
                    });
                    if (!_.isUndefined(wantedAccount)) {
                        return wantedAccount.account.name;
                    }
                }
                return 'FILTER_NO_ACCOUNT_ASSIGNED';
            },

            /**
             * Validates if the defined account container is suitable for live analytics
             * @param {Object} accountContainer The UM account container
             * @returns {boolean}
             */
            isCompatibleWithRealTime: function(accountContainer) {
                const specification = _.cloneDeep(_.get(accountContainer, 'specification'));

                filterUtils.cleanEmptyContainers(_.get(specification, 'containers'));

                return AccountContainer.isValidForRealTime(specification);
            }
        };
    }
})(window.angular);
